export function toOneDomainFilter(localeService) {
    return function (value) {
        if (!value || value.startsWith('//')) {
            return value;
        }
        var _a = localeService.currentLocale(), locale = _a.locale, isInPath = _a.isInPath;
        // Handle relative URLs only
        if (!isInPath || !value.startsWith('/')) {
            return value;
        }
        if (!value.startsWith("/" + locale)) {
            return "/" + locale + value;
        }
        return value;
    };
}
